/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Empty_DescriptionInputs */

const en_admin_resources_resource_allocations_empty_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add offices, desks, or equipment to start renting them out to your members and teams.`)
};

const de_admin_resources_resource_allocations_empty_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büros, Schreibtische oder Equipment hinzufügen, um sie an Mitglieder und Teams zu vermieten.`)
};

const es_admin_resources_resource_allocations_empty_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade despachos, escritorios o equipamiento para empezar a alquilarlos a tus miembros y equipos.`)
};

const fr_admin_resources_resource_allocations_empty_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez des bureaux, des postes de travail ou du matériel pour commencer à les louer à vos membres et équipes.`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_empty_description = en_admin_resources_resource_allocations_empty_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_empty_description = en_admin_resources_resource_allocations_empty_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_empty_description = en_admin_resources_resource_allocations_empty_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_empty_description = en_admin_resources_resource_allocations_empty_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_empty_description = en_admin_resources_resource_allocations_empty_description;

/**
* | output |
* | --- |
* | "Add offices, desks, or equipment to start renting them out to your members and teams." |
*
* @param {Admin_Resources_Resource_Allocations_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_empty_description = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Empty_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Empty_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_empty_description(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_empty_description(inputs)
	return ro_admin_resources_resource_allocations_empty_description(inputs)
});
export { admin_resources_resource_allocations_empty_description as "admin.resources.resource_allocations.empty_description" }